






























































import Vue from 'vue';
import tableComponent from '@/components/TheTable.vue';
import cardInfoComponent from '@/components/TheCardInfo.vue';
import titlePageComponent from '@/components/TheTitlePage.vue';
import SidebarRight from '@/components/TheSidebarRight.vue';
import {
  requestTransferShares,
  requestTreasuryWallet
} from '@/constants/sidebarData';
import transferPdfMaker from '@/helpers/pdfmakers/transfer';
import shareholdersPdfMaker from '@/helpers/pdfmakers/shareholders';
import { formatData } from '@/constants/commonContent';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import Component from 'vue-class-component';
import { Base } from '@/base';

const FORMAT_DATE = formatData.dateTime;

const lockIconSvg = require('@/assets/images/lock-icon.svg');
const pazzleIconSvg = require('@/assets/images/pazzle-icon.svg');

@Component({
  name: 'ShareholderPage',
  components: {
    tableComponent,
    cardInfoComponent,
    titlePageComponent,
    SidebarRight,
    PulseLoader
  }
})
export default class ShareholderPage extends Base {
  btnText = 'Transfer shares';
  titleText = 'COMPANY UPDATES';
  titleBg = 'pink-title';
  requestFormShareholders = requestTransferShares;
  membersTable = {
    titleText: 'LIST OF SHAREHOLDERS',
    titleBg: 'green-blue',
    sorted: 'id',
    columns: [
      { field: 'id', title: '#' },
      { field: 'name', title: 'NAME' },
      { field: 'email', title: 'EMAIL' },
      { field: 'position', title: 'POSITION' },
      { field: 'holding', title: 'HOLDING' },
      { field: 'percent', title: '% OF TOTAL SUPPLY' }
      ],
    rows: []
  };
  transfersTable = {
    titleText: 'PAST TRANSFERS',
    titleBg: 'pink-title',
    sorted: 'id',
    columns: [
      { field: 'rowId', title: '#' },
      { field: 'from', title: 'FROM' },
      { field: 'to', title: 'TO' },
      { field: 'value', title: 'AMOUNT' },
      { field: 'date', title: 'DATE' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };

  // Computed
  get isTransferTokenPending () {
    return this.getPendings.transferToken.new;
  }
  get hasMembers () {
    return this.membersTable.rows.length > 0;
  }
  get isAgent () {
    return this.isReader;
  }
  get membersData () {
    let rows: any[] = [];
    const TOTALSUPPLY = this.getTokenInfo.totalSupply;
    for (let variable in this.getMembers) {
      let row: any = {};
      let member = this.getMembers[variable];
      row.id = member.id;
      row.name = member.name;
      row.email = member.email;
      row.position = member.position;
      row.holding = this.getTokenBalance(variable);
      let percent = ((row.holding / TOTALSUPPLY) * 100).toFixed(5);
      percent = percent === '0.00' && row.holding > 0 ? (percent = '0.01') : percent;
      percent = percent === '100.00' && row.holding < TOTALSUPPLY ? (percent = '99.99') : percent;
      row.holding = formatData.number(row.holding);
      row.percent = percent + '%';
      rows.push(row);
    }
    Vue.set(this.membersTable, 'rows', rows);
    return this.membersTable;
  }
  get transfersData () {
    let rows: any[] = [];
    let index = 0;
    for (let variable in this.getTokenTransfers) {
      let row: any = {};
      let transfer = this.getTokenTransfers[variable];
      if (transfer.mode === 2 || transfer.status !== 3) continue; // it's a markettrade transfer
      let from = transfer.from;
      let to = transfer.to;
      row.rowId = index += 1;
      row.id = transfer.id;
      row.from = this.getMember(from) ? this.getMember(from).name : from;
      row.to = this.getMember(to) ? this.getMember(to).name : to;
      row.value = formatData.number(transfer.value);
      row.date = this.$moment.unix(transfer.date).format(FORMAT_DATE);
      rows.push(row);
    }
    Vue.set(this.transfersTable, 'rows', rows);
    return this.transfersTable;
  }
  get getInfoCards () {
    return [
      {
        id: 0,
        count: formatData.number(this.getTokenInfo.totalSupply),
        className: 'blue-bg',
        info: '//total supply',
        letter: this.getTokenInfo.firstSymbol,
        edit: false,
        pending: false
      },
      {
        id: 1,
        count: formatData.number(this.getCompanyBalance),
        className: 'orange-bg',
        info: '//treasury wallet ',
        icon: lockIconSvg,
        edit: (this.getCompanyInfo.wallet == 0 && this.isOwner() && !this.isAgent),
        pending: this.getPendings.companyTreasuryWallet.new,
        action: this.editTreasureWallet
      },
      {
        id: 2,
        count: this.majorMember ? formatData.number(this.majorMember.balance) : '0',
        className: 'green-bg',
        info: '//major shareholder: ' + this.majorMember.name,
        icon: pazzleIconSvg,
        edit: false,
        pending: false
      }
    ];
  }
  get majorMember () {
    let maxAddress;
    let maxValue = 0;
    for (let address in this.getMembers) {
      if (this.getTokenBalance(address) > maxValue) {
        maxValue = this.getTokenBalance(address);
        maxAddress = address;
      }
    }
    return {
      name: this.getMembers[maxAddress] ? this.getMembers[maxAddress].name : '',
      balance: this.getTokenBalance(maxAddress) ? this.getTokenBalance(maxAddress) : 0
    };
  }

  // Methods
  requestTransfer () {
    this.setSideBarForm(requestTransferShares(this.getMembers));
    this.openClose();
  }
  editTreasureWallet () {
    this.setSideBarForm(requestTreasuryWallet());
    this.openClose();
  }
  downloadTransfer (row) {
    const transfer = this.getTokenTransfers[row.id];
    const filename = this.getTokenInfo.symbol + '_transfer_#' + (row.id + 1);
    transferPdfMaker(
      row,
      transfer,
      this.getMember,
      this.getOwners,
      this.getCompanyInfo
    ).download(filename);
  }
  downloadShareholders () {
    const shareholders = { ...this.membersTable };
    shareholders.columns = [
      { field: 'id', title: '#' },
      { field: 'name', title: 'NAME' },
      { field: 'email', title: 'EMAIL' },
      { field: 'holding', title: 'HOLDING' },
      { field: 'percent', title: '% OF TOTAL SUPPLY' }
    ]
    const fileName = this.getTokenInfo.symbol + '_shareholders';
    shareholdersPdfMaker(shareholders, this.getMember, this.getOwners).download(fileName);
  }
};
